import axios from 'axios';

export function post(endpoint, body, options = { token: '', traceId: '', headers: {} }) {
    const { token, headers, traceId } = options;

    return new Promise((resolve) => {
        const reqHeaders = {
            authorization: 'Bearer ' + token,
            'x-trace-id': traceId,
            ...headers,
        };
        axios.post(endpoint, body, { headers: reqHeaders })
            .then(resolve)
            .catch(resolve);
    });
}

export default post;
